/* src/app/components/controls/dialogs/sem-quick-create-form-dialog/sem-quick-create-form-dialog.component.css */
:host ::ng-deep .wg-quick-create-dialog .popup-inner-content {
  position: relative;
  max-height: 75vh;
  overflow: auto;
}
:host ::ng-deep .wg-quick-create-dialog .popup-inner-content.wg-quick-create-busy {
  overflow: hidden;
}
.wg-quick-create-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.72);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  cursor: progress;
}
:host ::ng-deep .wg-quick-create-overlay .loader {
  position: relative;
  inset: auto;
  margin: 0;
}
.wg-quick-create-overlay__text {
  color: #475569;
  font-size: 13px;
  font-weight: 500;
}
.btn-group-param-popup button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
:host ::ng-deep .wg-quick-create-dialog .sub-nav-menu,
:host ::ng-deep .wg-quick-create-dialog .wg-toolbar {
  display: none !important;
}
.wg-quick-create-loading {
  padding: 24px 0;
  text-align: center;
  color: #64748b;
  font-size: 13px;
}
.wg-quick-create-error {
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13px;
}
/*# sourceMappingURL=sem-quick-create-form-dialog.component.css.map */
